var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSurveylexBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-surveylex-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.991305,89.7927312 L115.991305,97.4026184 C115.991305,104.361406 110.350093,110.002618 103.391305,110.002618 C100.245011,110.002618 97.2125542,108.825499 94.8902595,106.702738 L85.7572361,98.3544304 L28,98.3544304 C12.536027,98.3544304 1.8937905e-15,85.8184034 0,70.3544304 L-3.55271368e-15,28 C-5.44650418e-15,12.536027 12.536027,-7.12027924e-16 28,-3.55271368e-15 L88,-3.55271368e-15 C103.463973,-6.39339943e-15 116,12.536027 116,28 L116,89.3944304 C116,89.527899 115.997082,89.6606861 115.991305,89.7927312 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-6.8%",
    width: "118.1%",
    height: "119.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.160694067 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-surveylex-blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4275FF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 67.0843373,
    y: 67.443038,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 67.0843373,
    y: 50.5822785,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 83.8554217,
    y: 67.443038,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 83.8554217,
    y: 50.5822785,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 37.7349398,
    y: 33.721519,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 53.1084337,
    y: 67.443038,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 53.1084337,
    y: 50.5822785,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 53.1084337,
    y: 33.721519,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 37.7349398,
    y: 16.8607595,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 22.3614458,
    y: 67.443038,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 22.3614458,
    y: 50.5822785,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 37.7349398,
    y: 50.5822785,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 22.3614458,
    y: 33.721519,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 37.7349398,
    y: 67.443038,
    width: 12.5783133,
    height: 12.6455696,
    rx: 6.28915663
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSurveylexBlue);
export default __webpack_public_path__ + "static/media/ico-surveylex-blue.df9c58f94c64206a4d8712b1dc96cd5e.svg";
export { ForwardRef as ReactComponent };